// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDtIO5bnL5yHEQ51nL6a8AaCLwDYwOWDGY",
    authDomain: "nutripet-cd830.firebaseapp.com",
    projectId: "nutripet-cd830",
    storageBucket: "nutripet-cd830.appspot.com",
    messagingSenderId: "420447346159",
    appId: "1:420447346159:web:87ed22f686f5d2a6e72a1a",
    measurementId: "G-Q51KB7R0VM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
